import { render } from "./Index.vue?vue&type=template&id=6b639bd0"
const script = {}
script.render = render

export default script